import * as R from 'ramda';

export const valueOrNA = (collection, item) => {
  const prop = R.prop(item, collection);
  if (R.isNil(prop)) {
    return 'N/A';
  } else {
    return prop;
  }
};



// WEBPACK FOOTER //
// ./src/Common/valueOrNA/index.js